// Конфиг проекта
const projectConfig = {
  payment: false, // Флаг, отвечающий за отображение модулей: услуги, счета, корзина(в хедере тоже)
  feedback: false, // Флаг, отвечающий за отображение модуля "Обратная связь"
  crt_person: false, // Флаг, отвечающий за кликабельность и визуальное выделение слово "подтверждения" в баннере на главной странице

  // Флаг, отвечающий за показ стоимости услуги в карточке врача (шаг "Врач" при записи на прием).
  // true  - цена видна сразу, как у пациента без карты: источник оплаты всегда "П", поэтому
  //         цена из расписания одинаковая для всех
  // false - старая схема: подтвержденному пользователю цена приходит ответом по номерку,
  //         то есть видна только после клика по времени
  COST_SHOW: true,

  showCaptcha: false, // Флаг, который отвечает за то показывать ли капчу 
  idCaptcha: 'ysc1_WbpfdFWwDFnI6JGnIas40paYhPtlDD7anl26CX7n9cb1eb10', // клиентский ключ капчи

  // Онлайн-чат amoCRM (CRM Plugin). id и hash — из кода кнопки, вкладка «Установить»; они публичные
  amoChat: {
    widget: true, // плавающая кнопка чата на всех разделах ЛК — единственный режим чата
    buttonId: '450111',
    buttonHash: '04c50318ad9a0b3a51c60082946dfe7cd77ea58dbead20e08cf01426995c3730',
    locale: 'ru'
  },

  onlineAppointmentMainUrl: 'https://appointment.medilavia.ru/main'
}

export default projectConfig;